import { Ref, ref } from "vue";
import { DTOTrackerLeaving } from "vue-app/api/dto";
import { getTrackerLeaving, putWithdrawTracker } from "vue-app/api/TrackerLeavingService";
import { showIntercomNewMessage } from "vue-app/utils/functions";

interface RemoveTrackerData extends Omit<DTOTrackerLeaving, "scheduledRemovalDate"> {
  scheduledRemovalDate: string | null;
}

const removeTrackerData: Ref<RemoveTrackerData | null> = ref(null);
export default () => {
  const showRestoreAccountModal = ref(false);
  const error = ref(false);
  const getTrackerLeaveData = async () => {
    try {
      removeTrackerData.value = await getTrackerLeaving();
    } catch (e) {
      error.value = true;
    }
  };

  const isLoading = ref(false);
  const handleRestore = async () => {
    isLoading.value = true;
    try {
      if (removeTrackerData.value) {
        await putWithdrawTracker(removeTrackerData.value.trackerLeavingId);
        removeTrackerData.value = null;
        window.showToast(window._trans._cancellation.accountRestored, "success");
      }
    } catch (e) {
      error.value = true;
      window.showToast(window._trans._cancellation.errorRestore, "error");
    } finally {
      isLoading.value = false;
    }
  };

  const handleIntercom = () => {
    showIntercomNewMessage(window._trans._cancellation.message);
  };

  return {
    isLoading,
    showRestoreAccountModal,
    getTrackerLeaveData,
    removeTrackerData,
    handleRestore,
    handleIntercom,
  };
};
